<template>
  <div>
    <Head title="All Vouchers" />
    <h1 class="mb-8 text-3xl font-bold">All Vouchers</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link class="btn-orange" href="/vouchers/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Voucher</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date</th>
          <th class="pb-3 pt-3 px-3">Code</th>
          <th class="pb-3 pt-3 px-3">Description</th>
          <th class="pb-3 pt-3 px-3">Reason</th>
          <th class="pb-3 pt-3 px-3">Customer</th>
          <th class="pb-3 pt-3 px-3">Channel</th>
          <th class="pb-3 pt-3 px-3 items-end justify-end">Value</th>
          <th class="pb-3 pt-3 px-3">Type</th>
          <th class="pb-3 pt-3 px-3">Status</th>
        </tr>
        <tr v-for="voucher in vouchers.data" :key="voucher.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/vouchers/${voucher.id}`">
              {{ voucher.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/vouchers/${voucher.id}`">
              {{ voucher.code }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/vouchers/${voucher.id}`">
              {{ voucher.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/vouchers/${voucher.id}`">
              {{ voucher.reason }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/vouchers/${voucher.id}`">
              {{ voucher.customer }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/vouchers/${voucher.id}`">
              {{ voucher.channel }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-end justify-end  px-3 py-3 focus:text-orange-500" :href="`/vouchers/${voucher.id}`">
              {{ voucher.value }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/vouchers/${voucher.id}`">
              {{ voucher.type }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/vouchers/${voucher.id}`">
              {{ voucher.status }}
            </Link>
          </td>
        </tr>
        <tr v-if="vouchers.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="9">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="vouchers.links" />
  </div>
</template>
  
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
  
export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    vouchers: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user
    },
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/vouchers', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
  